// Bump this whenever player-facing code changes so the TV Wall can flag screens
// that are still running an older build and need a reboot/refresh.
// Keep this value in sync with APP_VERSION in /public/tv.html.
export const APP_VERSION = "2026.06.29";
